import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.regexp.split.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { asTree } from 'prismic-richtext';
import { NODE_ELEMENTS } from './RichTextConst';
var getNodeName = function getNodeName(_ref) {
  var type = _ref.type;
  return NODE_ELEMENTS[type] || null;
};
var getAttributes = function getAttributes(arg) {
  return {
    attrs: {
      href: arg.url
    }
  };
};
var getClasses = function getClasses(arg, cls) {
  return {
    class: [arg.label, cls]
  };
};
var getProps = function getProps(_ref2, _ref3) {
  var _ref2$element$data = _ref2.element.data,
    data = _ref2$element$data === void 0 ? {} : _ref2$element$data;
  var cls = _ref3.cls;
  return _objectSpread(_objectSpread({}, getAttributes(data)), getClasses(data, cls));
};
export default {
  functional: true,
  props: {
    payload: {
      type: Array,
      required: true
    },
    cls: {
      type: String,
      default: ''
    }
  },
  render: function render(h, _ref4) {
    var props = _ref4.props;
    var reducer = function reducer(acc, text, idx) {
      if (idx > 0) {
        acc.push(h('br'));
      }
      acc.push(text);
      return acc;
    };
    var injectBR = function injectBR(text) {
      var _text$split;
      return text === null || text === void 0 ? void 0 : (_text$split = text.split('\n')) === null || _text$split === void 0 ? void 0 : _text$split.reduce(reducer, []);
    };
    var elementBuilder = function elementBuilder(node) {
      var NodeName = getNodeName(node);
      if (NodeName == null) {
        return injectBR(node.text);
      }
      return h(NodeName, _mergeJSXProps([{}, getProps(node, props)]), [node.children.length > 0 ? node.children.map(elementBuilder) : injectBR(node.text)]);
    };
    return asTree(props.payload).children.map(elementBuilder);
  }
};